<template>
  <div class="chatbot-q">
    <AskQuestion v-if="message.history"  :question="message.userInput"/>
    <el-avatar class="chat-avatar" :src="chatHead"></el-avatar>
    <div class="chatbot-q-content">
      <p v-html="title"></p>
      <ul class="service-qa">
        <li v-for="(item, index) in items" :key="index"><span @click="askQuestion(item)">{{item}}</span></li>
        <li @click="showContactDialog">没有你想要的问题？ 点我试试</li>
      </ul>
    </div>      
    <ChatbotDialog :initial-dialog-visible="contactDialogVisible" @sendDialogActionValue="getDialogActionValue"></ChatbotDialog>
  </div>
</template>

<script>
// import ChatbotWelcome from '@/components/Welcome'
import ChatbotDialog from '@/components/Dialog'
import AskQuestion from '@/components/AskQuestion'
import { getMessageList } from '@/utils/index'


  export default {
  name: 'QuestionList',
  components:{
    // ChatbotWelcome,
    ChatbotDialog,
    AskQuestion,
  },
  data(){
    return {
      items:[],
      title: '',
      chatHead: '/static/images/chat-head.png',
      contactDialogVisible: false,
    }
  },
  mounted() {
    const {options, title} = this.message
    this.items = options
    this.title = title
  },
  methods: {
    showContactDialog() {
      this.contactDialogVisible = true
    },
    getDialogActionValue(value){
      this.contactDialogVisible = value
    },
    async askQuestion(item){
      const that = this
      getMessageList(item, that)
    }
  },
  props:{
    message: Object,
  },
}
</script>

<style>
.chatbot-q-content p{
  margin-bottom:0px;
}
.service-qa {
  text-align:left;
  list-style:none;
  padding-left:0px;
  margin-top:5px;
}
.service-qa li{
  line-height:35px;
  color:#D72618;
}
.service-qa span{
  display: inline-block;
  line-height: 24px;
  color:#D72618;
}
</style>
